@if (appUpdate.showNotice()) {
<div class="update-notice" role="status" aria-live="polite">
  <div class="update-notice-text">
    <strong i18n="@@app-update.title">Hay una versión nueva disponible</strong>
    <span i18n="@@app-update.text">Recarga la página para usarla.</span>
  </div>
  <button
    type="button"
    class="update-notice-button"
    (click)="appUpdate.reload()"
    i18n="@@app-update.reload">
    Recargar
  </button>
</div>
}
